export const apiConstants = {
  // eslint-disable-next-line no-undef
  apiUrl: process.env.REACT_APP_API_URL || 'https://backend.edraakonline.com/api/v1',
  imgUrl: process.env.REACT_APP_IMG_URL || 'https://backend.edraakonline.com/',
  // apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1',
  // imgUrl: process.env.REACT_APP_IMG_URL || 'http://localhost:8080/',


};
